import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Gift } from 'lucide-react';
import { Ginger } from './botanical/Ginger';
import { Eucalyptus } from './botanical/Eucalyptus';
export function BonosSection() {
  const bonos = [{
    num: '01',
    icon: '🏥',
    title: 'BOTIQUÍN NATURAL EXPRESS',
    desc: 'Qué comprar, dónde conseguirlo y cómo organizarlo para tenerlo listo antes de que aparezca el malestar.',
    value: '$8.000'
  }, {
    num: '02',
    icon: '⚡',
    title: 'GUÍA RÁPIDA: QUÉ HACER PRIMERO',
    desc: 'Para cuando no tenés tiempo de pensar. Un síntoma, tres pasos, acción inmediata. Imprimila y pegala en la cocina.',
    value: '$7.000'
  }, {
    num: '03',
    icon: '🛒',
    title: 'LISTA DE COMPRAS DEL HOGAR NATURAL',
    desc: 'Exactamente qué ingredientes necesitás, en qué cantidad y dónde conseguirlos en Argentina sin gastar de más.',
    value: '$6.000'
  }, {
    num: '04',
    icon: '📅',
    title: 'CALENDARIO 7 DÍAS DE HÁBITOS NATURALES',
    desc: 'Un hábito por día durante 7 días para instalar el sistema sin esfuerzo. El puente entre leer y hacer.',
    value: '$7.000'
  }, {
    num: '05',
    icon: '👨‍👩‍👧‍👦',
    title: 'MINI GUÍA FAMILIAR',
    desc: 'Cómo adaptar cada protocolo según la edad. Para bebés, niños, adultos y mayores. Todo en un solo lugar.',
    value: '$8.000'
  }];
  return <Section className="bg-forest-deep text-cream-warm relative overflow-hidden" data-id="element-23">
      <Ginger className="absolute top-20 -left-16 w-64 h-64 text-honey opacity-10 blur-[2px] rotate-12" data-id="element-24" />
      <Eucalyptus className="absolute bottom-10 -right-20 w-80 h-80 text-moss opacity-15 blur-sm -rotate-45" data-id="element-25" />

      <div className="text-center mb-12 relative z-10" data-id="element-26">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-honey/20 mb-4 border border-honey/30" data-id="element-27">
          <Gift className="w-8 h-8 text-honey" data-id="element-28" />
        </div>
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-cream-warm" data-id="element-29">
          🎁 5 BONOS — SIEMPRE INCLUIDOS
        </h2>
      </div>

      <div className="max-w-5xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 relative z-10" data-id="element-30">
        {bonos.map((bono, idx) => <Card key={idx} className="bg-white/5 border-white/10 text-cream-warm p-6 flex flex-col h-full hoverable backdrop-blur-sm" data-id="element-31">
            <div className="flex items-center gap-3 mb-4" data-id="element-32">
              <span className="text-3xl" data-id="element-33">{bono.icon}</span>
              <div data-id="element-34">
                <div className="text-xs font-bold text-honey uppercase tracking-wider" data-id="element-35">
                  BONO {bono.num}
                </div>
                <h3 className="font-serif font-bold text-lg leading-tight text-cream-warm" data-id="element-36">
                  {bono.title}
                </h3>
              </div>
            </div>
            <p className="text-cream-warm/80 text-sm mb-6 flex-grow" data-id="element-37">
              {bono.desc}
            </p>
            <div className="mt-auto pt-4 border-t border-white/10 flex items-center justify-between text-sm" data-id="element-38">
              <span className="text-cream-warm/60 line-through" data-id="element-39">
                Valor: {bono.value}
              </span>
              <span className="font-bold text-honey bg-honey/10 px-2 py-1 rounded" data-id="element-40">
                → GRATIS
              </span>
            </div>
          </Card>)}
      </div>

      <div className="max-w-2xl mx-auto text-center bg-white/10 rounded-2xl p-6 border border-white/20 relative z-10 backdrop-blur-sm" data-id="element-41">
        <p className="text-xl md:text-2xl font-serif" data-id="element-42">
          <span className="opacity-80 line-through mr-3 text-cream-warm/70" data-id="element-43">
            VALOR TOTAL BONOS: $36.000
          </span>
          <span className="font-bold text-honey" data-id="element-44">
            → GRATIS con tu Hogar Natural
          </span>
        </p>
      </div>
    </Section>;
}